const API_BASE = "https://api.intra.42.fr";

export { API_BASE };
